import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeFirstAndLast',
})
export class ExcludeFirstAndLastPipe implements PipeTransform {
  public transform(value: any[]): any[] {
    return value.slice(1, value.length - 1);
  }
}
